export const useFormatNumber = () => {
	const formatNumber = (value) => {
		if (value === null || value === undefined || value === '') return '';
		const number = Number(value);
		if (Number.isNaN(number)) return String(value).trim();
		return new Intl.NumberFormat('ru-RU').format(number);
	};

	return {
		formatNumber,
	};
};